import { Route, Routes } from 'react-router-dom';
import './App.css';
import Layout from './pages/Layout';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import Login from './pages/Login';
import AboutUs from './pages/AboutUs';
import Boards from './pages/Boards';
import FAQ from './pages/FAQ';
import InterestSites from './pages/InterestSites';
import ReportPublic from './pages/ReportPublic';
import Admin from './pages/Admin';
import Normativa from './pages/Normativas';
import { useEffect } from 'react';
import MessageOwner from './components/MessageOwner';
import IntegralPrivacy from './pages/IntegralPrivacy';
import SimplePrivacy from './pages/SimplePrivacy';
import Declaranet from './pages/Declaranet';
import EticayConducta from './pages/EticayConducta';
import ResultSearch from './components/ResultSearch';
import Observer from './pages/Observer';

function App() {
  useEffect(() => {
    document.title = "OIC";
  });

  return (
    <Routes>
      <Route path="/" element={<Layout />} />
      <Route path="/login" element={<Login />} />
      <Route path="/message" element={<MessageOwner />} />
      <Route path="/aboutus" element={<AboutUs />} />
      <Route path="/news" element={<News />} />
      <Route path="/newsdetail/:uuid" element={<NewsDetail />} />
      <Route path="/boards" element={<Boards />} />
      <Route path="/normativa" element={<Normativa />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/avisoprivacidad" element={<IntegralPrivacy />} />
      <Route path="/avisoprivacidadsimplificado" element={<SimplePrivacy />} />
      <Route path="/declaranet" element={<Declaranet />} />
      <Route path="/eticayconducta" element={<EticayConducta />} />
      <Route path="/sitios" element={<InterestSites />} />
      <Route path="/observador" element={<Observer />} />
      <Route path="/report/:type" element={<ReportPublic />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/searchresult" element={<ResultSearch />} />
    </Routes>
  );
}

export default App;
